import { render, staticRenderFns } from "./FooterCranialSymposium.vue?vue&type=template&id=be3fe2e2&"
import script from "./FooterCranialSymposium.vue?vue&type=script&lang=js&"
export * from "./FooterCranialSymposium.vue?vue&type=script&lang=js&"
import style0 from "./FooterCranialSymposium.vue?vue&type=style&index=0&id=be3fe2e2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports